<template>
  <v-container fluid>
    <ActionBar class="get-height" />

    <div
      :class="[`${
        isFailed || !items.length
          ? 'page__content--no-items'
          : 'page__content'
      }`, {
        'page__content--from-v4': noMainMenuFromV4
      }]"
    >
      <Filters
        :status="currentStatus"
        @change="updateFilters"
      />

      <Table
        :items="items"
        :pagination="pagination"
        :status="currentStatus"
        :drawerVisibility="drawerVisibility"
        @reloadData="reloadData"
        @goToPage="updatePage"
      />
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import ActionBar from 'components/users/ActionBar'
import Filters from 'components/users/Filters'
import Table from 'components/users/Table'

export default {
  name: 'UsersPage',
  components: {
    ActionBar,
    Filters,
    Table
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      selectedCompany: ({ company }) => company.selectedCompany,
      claims: ({ userClaims }) => userClaims.claims,
      noMainMenuFromV4: ({ mainMenu }) => mainMenu.noMainMenuFromV4
    }),

    isLoading () {
      return this.currentStatus === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },

    isFailed () {
      return this.currentStatus === STATUS_FAILED
    }
  },
  data () {
    return {
      namespace: 'Views.UsersPage',
      pagination: {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      },
      filters: {
        profile: null,
        search: null
      },
      currentStatus: STATUS_SUCCESS,
      items: [],
      selectedItem: null,
      drawerVisibility: true
    }
  },

  methods: {
    ...mapActions({
      showAlert: 'snackbar/show'
    }),

    updatePagination (response, itemsPerPage) {
      this.pagination = {
        ...this.pagination,
        totalElements: response.totalElements,
        totalPages: response.totalPages
      }
    },

    resetPagination () {
      this.pagination = {
        totalElements: 0,
        totalPages: 0,
        currentPage: 1,
        itemsPerPage: 25
      }
    },

    updateFilters (filters) {
      this.filters = { ...filters }
      this.reloadData()
    },

    updatePage (page) {
      scrollTo(0, 0)

      this.pagination = {
        ...this.pagination,
        currentPage: page
      }

      this.loadData()
    },

    async loadData () {
      this.currentStatus = STATUS_IS_LOADING

      try {
        const { currentPage, itemsPerPage } = this.pagination
        const companyId = this.selectedCompany ? this.selectedCompany.id : null
        const { profile, search } = this.filters
        const regex = /^([a-z]){1,}([a-z0-9._-]){1,}([@]){1}([a-z0-9._-]){2,}([.]){1}([a-z0-9._-]){2,}([.]?){1}([a-z0-9._-]?){2,}$/
        const searchIsEmail = regex.test(search)

        const { data: res } = await this.$apiService.users.get(
          { page: currentPage - 1 },
          { size: itemsPerPage },
          { profiles: profile },
          { companyIds: companyId },
          { email: searchIsEmail ? search : null },
          { search: !searchIsEmail ? search : null }
        )

        if (!res.valid) throw new Error()
        this.items = res.content ? res.content : []
        this.updatePagination(res, itemsPerPage)
        this.currentStatus = STATUS_SUCCESS
      } catch (err) {
        console.log('ERROR:', err)
        this.currentStatus = STATUS_FAILED
      }
    },

    reloadData () {
      this.resetPagination()
      this.loadData()
    }
  },

  watch: {
    selectedCompany () {
      this.reloadData()
    },

    filters: {
      deep: true,
      handler () {
        this.drawerVisibility = !this.drawerVisibility
      }
    }
  },

  mounted () {
    this.loadData()
  }
}
</script>
